import { useParams } from "react-router-dom"
import { Button, List, Typography } from "antd"
import { FileWordOutlined } from "@ant-design/icons"
import classNames from "classnames"

import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import UiStore from "@src/app/uiStore"
import css from "./index.module.css"

const { Paragraph } = Typography

const { Item } = List

export const KybInnerPage = () => {
  const { id } = useParams()

  return (
    <DefaultPageLayout title={`KYB Level ${id}`}>
      <div className={css.contentWrapper}>
        <Paragraph className={css.description}>
          Your {UiStore().theme} account has limitations on withdrawals and
          deposits, which are influenced by various factors such as
          verification. If you want to increase your limits, please fill out the
          Questionnaire and send it to{" "}
          <Button
            className={css.mailLink}
            href="mailto:onboarding@cryptix.io"
            id="GENERATED_ID_KYBINNER_BUTTON_ONBOARDINGCRYPTIXIO_1"
            type="link"
          >
            onboarding@cryptix.io
          </Button>
          , also attaching documents from the list below.
        </Paragraph>
        <div>
          <List
            header={
              <span className={css.documentsTitle}>
                The following documents (certified copies) shall be attached to
                the Questionnaire:
              </span>
            }
          >
            <Item className={css.listItem}>
              <span className={css.text}>
                Сertificate of incorporation/registration
              </span>
            </Item>
            <Item className={css.listItem}>
              <span className={css.text}>
                Share Registry/ Shareholder Register
              </span>
            </Item>
            <Item className={css.listItem}>
              <span className={css.text}>Lisence (if applicable)</span>
            </Item>
            <Item className={css.listItem}>
              <span className={css.text}>
                Account holder ID/passport (this must be a
                director/beneficiary/other official representative of the legal
                entity)
              </span>
            </Item>
            <Item
              className={classNames(
                css.listItem,
                css.innerListWrapper,
                css.noDot,
              )}
            >
              <span className={css.text}>
                Document connecting the company to the account holder (it is
                necessary to confirm that the official representative of the
                company has the right to act on its behalf). This document may
                be:
              </span>
              <List>
                <Item className={css.listItem}>
                  <span className={css.text}>Power of Attorney</span>
                </Item>
                <Item className={css.listItem}>
                  <span className={css.text}>Shareholder Register</span>
                </Item>
                <Item className={css.listItem}>
                  <span className={css.text}>Certificate of Incumbency</span>
                </Item>
                <Item className={css.listItem}>
                  <span className={css.text}>Register of Directors</span>
                </Item>
                <Item className={css.listItem}>
                  <span className={css.text}>Declaration of trust</span>
                </Item>
                <Item className={css.listItem}>
                  <span className={css.text}>Extract from the Register</span>
                </Item>
              </List>
            </Item>
            {id === "2" && (
              <Item className={css.listItem}>
                <span className={css.text}>
                  Additional documents may be requested depending on the type of
                  activity of the company (for example, Annual financial
                  statements and etc)
                </span>
              </Item>
            )}
          </List>
        </div>
        <Button
          className={css.button}
          download="merchants-questionnaire"
          href={require("../../app/example/merchants-questionnaire.docx")}
          icon={<FileWordOutlined />}
          id="GENERATED_ID_KYBINNER_BUTTON_DOWNLOAD_QUESTIONNAIRE_1"
          size="large"
          type="primary"
        >
          Download Questionnaire
        </Button>
      </div>
    </DefaultPageLayout>
  )
}
